import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ScheduleDashboardPeriodsQueryCgResponse,
  ScheduleDashboardPeriodsQueryVariables,
} from '@common/graphql';

// Schedule Dashboard listing: service-line groups, each carrying its (scheduling
// period × organization unit) rows — server-side filtered, sorted, and offset-paginated
// at the GROUP level (`totalGroupCount` pages over service-line groups). The per-status
// `statusCounts` populate the tab badges and are NOT status-filtered (so every tab shows
// its real total across the whole authorized set regardless of the active tab/filters).
export const SCHEDULE_DASHBOARD_PERIODS_QUERY: TypedDocumentNode<
  ScheduleDashboardPeriodsQueryCgResponse,
  ScheduleDashboardPeriodsQueryVariables
> = gql`
  query ScheduleDashboardPeriods(
    $statuses: [LoadBalancingScheduleDashboardStatus!]
    $filters: LoadBalancingScheduleDashboardFilterInput
    $limit: Int!
    $offset: Int!
    $orderField: LoadBalancingScheduleDashboardOrderField
    $orderDirection: OrderDirection
  ) {
    scheduleDashboardPeriods(
      statuses: $statuses
      filters: $filters
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderDirection: $orderDirection
    ) {
      totalGroupCount
      statusCounts {
        workloadPlanning
        selfScheduling
        balancing
        overdue
        completed
        all
      }
      filterOptions {
        periods {
          id
          periodStart
          periodEnd
        }
        units {
          id
          name
        }
      }
      groups {
        serviceLineId
        serviceLineName
        needsTeamReview
        teamReviewSchedulingPeriodId
        periods {
          id
          schedulingPeriodId
          organizationUnitId
          periodStart
          periodEnd
          unit
          costCenter
          fillRate
          lastEditedAt
          dueDate
          status
          runId
          teamReviewComplete
        }
      }
    }
  }
`;
